export const not = <T>(func: (obj: T) => boolean): ((obj: T) => boolean) => {
  return (obj) => !func(obj);
};
